export default "__VITE_ASSET__CbLeRlrZ__"